import { createContext, useContext, type ReactNode, type RefObject } from "react";

const PortalContainerContext = createContext<RefObject<HTMLDivElement> | null>(
  null
);

export function PortalContainerProvider({
  containerRef,
  children,
}: {
  containerRef: RefObject<HTMLDivElement>;
  children: ReactNode;
}) {
  return (
    <PortalContainerContext.Provider value={containerRef}>
      {children}
    </PortalContainerContext.Provider>
  );
}

export function usePortalContainer(): HTMLElement | undefined {
  const ref = useContext(PortalContainerContext);
  return ref?.current ?? undefined;
}
